var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
export var CubeMaker = function (_a, props) {
    var position = _a.position, size = _a.size, rot = _a.rot, color = _a.color, meshRef = _a.meshRef;
    return (React.createElement("mesh", __assign({}, props, { position: [position[0], position[1], position[2]], rotation: rot, scale: [size[0], size[1], size[2]], ref: meshRef || null }),
        React.createElement("planeGeometry", null),
        React.createElement("meshStandardMaterial", { color: color || 'black', opacity: 0.6, transparent: true })));
};
